<template>
  <div class="shopping-cart">
    <TextHead :title="'购物车'" />

    <div class="cart-body w1200">
      <div class="empty">
        <i class="icon el-icon-shopping-cart-1"></i>
        <div class="text">
          <div>购物车内暂无商品，登录后将显示您之前加入的商品</div>
          <el-button type="text" @click="goLogin">挑选商品 ></el-button>
        </div>
      </div>
    </div>

    <MallFooter />
  </div>
</template>

<script>
import TextHead from "@/views/TextHead.vue";
import MallFooter from "@/views/MallFooter.vue";
export default {
  name: "shoppingCart",
  components: {
    TextHead,
    MallFooter,
  },
  methods: {
    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-body {
  width: 1000px;
  border: 1px solid #e6e6e6;
  .empty {
    display: flex;
    justify-content: center;
    padding: 56px 0;
    text-align: center;
    font-size: 12px;
    .icon {
      font-size: 70px;
      color: #cccccc;
    }
    .el-button {
      padding: 0;
      font-size: 12px;
    }
    .text {
      padding-top: 12px;
      padding-left: 20px;
      div {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
